"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Version = void 0;
var _react = _interopRequireDefault(require("react"));
var Version = exports.Version = function Version(_ref) {
  var packageVersion = _ref.packageVersion;
  if (!packageVersion) {
    return null;
  }
  var displayVersion = "v".concat(packageVersion.replace(/\-silent/, ""));
  return _react["default"].createElement("small", {
    title: 'Current Shoflo version',
    className: "version-identifier"
  }, displayVersion);
};